import { Component, Input, OnChanges } from "@angular/core";
import { HelpTarget } from "src/app/interfaces/helpTarget";
import { NavigationService } from "src/app/services";
import {
  IPermissionExtendedStep,
  IStepAssignee,
  IStepInit
} from "../../../interfaces";
import { LogClass, Logger } from "../../../logger";

@Component({
    selector: "circ-step-current",
    templateUrl: "./current-step.component.html",
    styleUrls: ["./current-step.component.scss"],
    standalone: false
})
@LogClass({ source: "CurrentStepComponent" })
export class CurrentStepComponent implements OnChanges {
  @Input() public steps: IPermissionExtendedStep[];

  public readonly helpTarget = HelpTarget.Tasks;
  public currStep: IPermissionExtendedStep;
  public uniqueAssignees: IStepAssignee[] = [];
  private logger: Logger;
  public toggleActions = false;

  public onWork(step: IStepInit): void {
    this.navigate.toStepWork(step.circulationId, step.id);
  }

  public onForward(step: IStepInit): void {
    this.navigate.toStepForward(step.circulationId, step.id);
  }

  constructor(private navigate: NavigationService) {
    this.logger.debug("ctor");
  }

  public ngOnChanges(): void {
    // Check if the data exists before using it
    if (!this.steps) {
      return;
    }

    this.currStep = this.steps.find((y) => y.status == "InProgress");
    if (!this.currStep) {
      return;
    }

    const assignees = this.currStep.tasks?.assignees || [];
    this.uniqueAssignees = assignees.filter((a) => a.result !== "Forwarded");
  }
}
